import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatMenuModule} from '@angular/material/menu';
import {FormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatRippleModule} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {CurrencyInputComponent} from "./currency-input.component";



@NgModule({
    declarations: [CurrencyInputComponent],
    exports: [
        CurrencyInputComponent
    ],
    imports: [
        CommonModule,
        MatMenuModule,
        FormsModule,
        MatFormFieldModule,
        MatIconModule,
        MatMenuModule,
        MatRippleModule,
        MatDialogModule,
        MatInputModule,
        MatButtonModule
    ]
})
export class CurrencyInputModule { }
